<template>
  <v-container>
    <v-card>
      <v-card-title>Minhas Solicitações</v-card-title>
      <v-card-text>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar" single-line
          hide-details></v-text-field>

        <!-- Table for larger screens -->
        <v-data-table v-if="!isMobile" :headers="headers" :items="solicitacoes" :search="search" :loading="loading"
          loading-text="Buscando solicitações..." no-data-text="Nenhuma solicitação encontrada." class="elevation-1 mt-4">
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.DATA_RECEBIMENTO="{ item }">
            {{ formatDate(item.DATA_RECEBIMENTO) }}
          </template>
          <!-- eslint-disable-next-line vue/valid-v-slot -->
          <template v-slot:item.SITUACAO_PEG="{ item }">
            <v-chip :color="getStatusInfo(item.SITUACAO_PEG).color" size="small" label>
              {{ getStatusInfo(item.SITUACAO_PEG).text }}
            </v-chip>
          </template>
        </v-data-table>

        <!-- Cards for smaller screens -->
        <div v-else>
          <v-card v-if="loading" class="my-4 text-center" elevation="0">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p>Buscando solicitações...</p>
          </v-card>
          <v-card v-else-if="filteredSolicitacoes.length === 0" class="my-4 text-center" elevation="0">
            <p>Nenhuma solicitação encontrada.</p>
          </v-card>
          <div v-else>
            <v-card v-for="item in paginatedSolicitacoes" :key="item.PROTOCOLO" class="my-4" elevation="2">
              <v-card-text>
                <div class="text-h6 font-weight-bold mb-2">{{ formatDate(item.DATA_RECEBIMENTO) }}</div>
                <div>{{ item.TIPO_PEG }}</div>
                <div>{{ item.NOME_BENEFICIARIO_ATENDIDO }}</div>
                <div class="text-caption mt-2">Protocolo: {{ item.PROTOCOLO }}</div>
                <v-chip :color="getStatusInfo(item.SITUACAO_PEG).color" size="small" label class="mt-2">
                  {{ getStatusInfo(item.SITUACAO_PEG).text }}
                </v-chip>
              </v-card-text>
            </v-card>
            <v-pagination v-model="page" :length="Math.ceil(filteredSolicitacoes.length / itemsPerPage)" rounded="circle" :total-visible="4" size="small"></v-pagination>
          </div>
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="elevated" @click="fecharPagina">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import axios from 'axios';
import { useDisplay } from 'vuetify';
import { useRoute } from 'vue-router';

const display = useDisplay();
const route = useRoute();
const search = ref('');
const loading = ref(true);
const solicitacoes = ref([]);
const page = ref(1);
const itemsPerPage = ref(5);

const headers = [
  { title: 'Protocolo', value: 'PROTOCOLO' },
  { title: 'Data de Solicitação', value: 'DATA_RECEBIMENTO' },
  { title: 'Tipo de Serviço', value: 'TIPO_PEG' },
  { title: 'Beneficiário Atendido', value: 'NOME_BENEFICIARIO_ATENDIDO' },
  { title: 'Situação', value: 'SITUACAO_PEG' },
];

const isMobile = computed(() => {
  return ['xs', 'sm'].includes(display.name.value);
});

const filteredSolicitacoes = computed(() => {
  if (!search.value) {
    return solicitacoes.value;
  }
  return solicitacoes.value.filter(item => {
    return Object.values(item).some(val =>
      String(val).toLowerCase().includes(search.value.toLowerCase())
    );
  });
});

const paginatedSolicitacoes = computed(() => {
  const start = (page.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return filteredSolicitacoes.value.slice(start, end);
});

onMounted(async () => {
  let cpf = route.query.cpf || localStorage.getItem('cpf_reembolso');
  if (cpf) {
    try {
      const response = await axios.post('https://n8n.app.cassems.com.br/webhook/protocolo-rembolso-cpf-hml', { cpf });
      solicitacoes.value = response.data.sort((a, b) => b.DATA_RECEBIMENTO.localeCompare(a.DATA_RECEBIMENTO));
    } catch (error) {
      console.error('Erro ao buscar solicitações:', error);
    } finally {
      loading.value = false;
    }
  } else {
    console.error('CPF não encontrado no localStorage ou na URL.');
    loading.value = false;
  }
});

const formatDate = (dateString) => {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('T')[0].split('-');
  return `${day}/${month}/${year}`;
};

const getStatusInfo = (situacao) => {
  const lowerSituacao = situacao?.toLowerCase() || '';

  if (['faturado', 'pronto'].includes(lowerSituacao)) {
    return { text: 'Finalizado', color: 'blue' };
  }
  if (['conferencia', 'verificação'].includes(lowerSituacao)) {
    return { text: 'Em andamento', color: 'yellow' };
  }
  if (lowerSituacao === 'digitação') {
    return { text: 'Recebido', color: 'green' };
  }

  return { text: situacao, color: 'grey' };
};

const fecharPagina = () => {
  const targetUrl = new URL('/solicitacao-encerrada', window.location.origin);
  window.top.location.href = targetUrl.href;
};

</script>
